import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";
import { formatDateShort, isUpcoming, truncate } from "@/lib/format";
import { Badge } from "./Primitives";

export default function EventCard({ event }) {
  return (
    <Link
      to={`/events/${event.slug}`}
      className="card-bcs flex flex-col group overflow-hidden"
      data-testid={`event-card-${event.slug}`}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={event.cover_image}
          alt={event.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <Badge tone={isUpcoming(event.event_date) ? "green" : "gray"}>
            {isUpcoming(event.event_date) ? "Upcoming" : "Past Event"}
          </Badge>
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-serif text-xl font-semibold text-ink leading-snug group-hover:text-maroon transition-colors">
          {event.title}
        </h3>
        <p className="mt-2 text-sm text-ink-soft leading-relaxed flex-1">
          {truncate(event.description, 110)}
        </p>
        <div className="mt-4 space-y-1.5 text-xs text-ink-muted">
          <p className="flex items-center gap-2">
            <Calendar size={14} className="text-gold-dark" /> {formatDateShort(event.event_date)}
            {event.event_time ? ` · ${event.event_time}` : ""}
          </p>
          <p className="flex items-center gap-2">
            <MapPin size={14} className="text-gold-dark" /> {event.venue}
          </p>
        </div>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-maroon">
          View details <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}
